<template>
    <div class="flexcol-fill overflow-hidden pa-3">
        <v-alert v-if="error !== null" color="error">
            {{ error }}
        </v-alert>
        <v-container v-if="data !== null" fluid class="pa-0 mb-5 flexcol-fix text-light">            
            <v-row class="mt-2">
                <v-col cols="auto" class="text-center border border-primary border-left-0 border-top-0 border-right-1 border-bottom-0" style="width: 17rem;">
                    <img :src="'/weather-icons/' + data.currentConditions.icon + '.svg'" class="iconFilter" style="width: 10rem; height: 10rem;"/>
                    <div class="mb-2">
                        {{ data.currentConditions.conditions }}
                    </div>
                    <div class="font-weight-bold text-xl">
                        {{ data.currentConditions.temp.toLocaleString() }}° C
                    </div>                    
                </v-col>
                <v-col>
                    <v-container fluid class="pa-0 mt-5">
                        <v-row no-gutters class="border-light border-b-sm border-opacity-100 mb-3">
                            <v-col cols="auto" class="font-weight-bold ">
                                Aktuelles Daten für {{ data.address }}
                            </v-col>
                        </v-row>                        
                        <v-row no-gutters class="mb-2">
                            <v-col cols="auto" style="width: 12rem;">Luftfeuchtigkeit:</v-col>
                            <v-col class="font-weight-bold">{{ data.currentConditions.humidity.toLocaleString() }}%</v-col>
                        </v-row>
                        <v-row no-gutters class="mb-2">
                            <v-col cols="auto" style="width: 12rem;">Sonnenaufgang:</v-col>
                            <v-col class="font-weight-bold">{{ data.currentConditions.sunrise.substr(0, 5) }} Uhr</v-col>
                        </v-row>
                        <v-row no-gutters class="mb-2">
                            <v-col cols="auto" style="width: 12rem;">Sonnenuntergang:</v-col>
                            <v-col class="font-weight-bold">{{ data.currentConditions.sunset.substr(0, 5) }} Uhr</v-col>
                        </v-row>
                        <v-row no-gutters class="mb-2">
                            <v-col cols="auto" style="width: 12rem;">Wind:</v-col>
                            <v-col class="font-weight-bold">{{ data.currentConditions.windspeed.toLocaleString() }} km/h</v-col>
                        </v-row>                                                                           
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid class="flexcol-fill overflow-hidden pa-0 border-light border-t-sm border-opacity-100 mt-3">
            <div class="flexcol-fix">
                <v-tabs v-model="selectedTab">
                    <v-tab value="heute">Heute</v-tab>
                    <v-tab value="naechsteTage">Die nächsten Tage</v-tab>
                </v-tabs>
            </div>
            <div class="flexcol-fill overflow-hidden">
                <v-tabs-window v-model="selectedTab" class="flexcol-fill overflow-hidden">
                    <v-tabs-window-item value="heute" class="flexcol-fill overflow-auto">
                        <v-container fluid class="pa-0 mt-3">
                            <v-row no-gutters>
                                <v-col cols="auto" v-for="s in stunden" v-bind:key="s.datetime" class="mr-2 mb-2">
                                    <div class="bg-secondary text-center pa-2" style="width: 8rem; height: 10rem; font-size: 1rem;">                                    
                                        <v-icon icon="mdi-clock-outline"/> {{ $dayjs(data.days[0].datetime + ' ' + s.datetime).format('HH:mm') }}
                                        <div class="m-2">
                                            <img :src="'/weather-icons/' + s.icon + '.svg'" class="iconFilter" style="width: 3rem; height: 3rem;"/>
                                        </div>
                                        <div style="font-size: 1.2rem; font-weight: bold;">{{ s.temp.toLocaleString() }}° C</div>                                    
                                        <div style="font-size: 0.8rem;">{{ s.conditions }}</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>                    
                    </v-tabs-window-item>
                    <v-tabs-window-item value="naechsteTage" class="flexcol-fill overflow-auto">
                        <v-container fluid class="pa-0 mt-3">
                            <v-row no-gutters>
                                <v-col cols="auto" v-for="t in tage" v-bind:key="t.datetime" class="mr-2 mb-2">
                                    <div class="bg-secondary text-center pa-3" style="width: 8rem; height: 10rem;">
                                        <div class="text-sm">
                                            <v-icon icon="mdi-calendar"/> {{ $dayjs(t.datetime).format('ddd DD.MM') }}
                                        </div>
                                        <div class="mt-2">
                                            <img :src="'/weather-icons/' + t.icon + '.svg'" class="iconFilter" style="width: 3rem; height: 3rem;"/>
                                        </div>
                                        <div>{{ t.tempmax.toLocaleString() }}° C</div>
                                        <div class="text-sm">{{ t.tempmin.toLocaleString() }}° C</div> 
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>                    
                    </v-tabs-window-item>
                </v-tabs-window>
            </div>
        </v-container>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        name: 'kc-weather',
        data() {
            return {
                apiUrl: 'https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/Rheindahlen?unitGroup=metric&lang=de&key={apiKey}&contentType=json',
                apiKey: 'ZTHU5KDVW5FEAFZWKML47ZHJ3',
                selectedTab: 'heute',
                timer: null,
                data: null,
                prototype: {
                    "latitude" : 38.9697,
                    "longitude" : -77.385,
                    "resolvedAddress" : "Reston, VA, United States",
                    "address" : " Reston,VA",
                    "timezone" : "America/New_York",
                    "tzoffset" : -5,
                    "description":"Cooling down with a chance of rain on Friday.",
                    "icon": null,
                    "days" : [{ //array of days of weather data objects
                        "datetime":"2020-11-12",
                        "datetimeEpoch":1605157200,
                        "temp" : 59.6,
                        "feelslike" : 59.6,
                        "source" : "obs",
                        "hours" : [{  //array of hours of weather data objects
                            "datetime" : "01:00:00"
                        }]
                    }],
                    "alerts" : [{
                            "event" : "Flash Flood Watch",
                            "description" : "..."
                        }
                    ],
                    "currentConditions" : {
                        "datetime" : "2020-11-11T22:48:35",
                        "datetimeEpoch" : 160515291500,
                        "temp" : 67.9
                    }
                },
                error: null
            }
        },
        mounted() {
            const vm = this;
            vm.timer = window.setInterval(() => {
                vm.refresh();
            }, 100000);
            vm.refresh();
        },
        demounted() {
            const vm = this;
            if (vm.timer !== null) vm.timer.stop;
        },
        computed: {
            stunden() {
                const vm = this;
                let tagIndex = 0;
                let stundenIndex = 0;           
                let jetzt = vm.$dayjs();
                let stunden = [];
                let anzahl = 0;
                if (vm.data === null) return  stunden;
                while(anzahl < 12) {
                    if (stundenIndex >= vm.data.days[tagIndex].hours.length) {
                        tagIndex++;
                        stundenIndex=0;
                    }                  
                    let tag = vm.data.days[tagIndex];                      
                    let stunde = tag.hours[stundenIndex];
                    if (!tag) {
                        console.log('Tag');
                    }
                    if (!stunde) {
                        console.log('Stunde');
                    }                    
                    let zeit = vm.$dayjs(tag.datetime + ' ' + stunde.datetime);
                    if (!zeit.isBefore(jetzt)) {
                        stunden.push(stunde);
                        anzahl++;
                    }
                    stundenIndex++;                    
                }
                return stunden;
            },
            tage() {
                const vm = this;
                let tage = [];
                let tagIndex = 1;
                while(tage.length < 12) {
                    tage.push(vm.data.days[tagIndex]);
                    tagIndex++;
                }
                return tage;
            }
        },
        methods: {
            refresh() {
                const vm = this;
                vm.error = null;
                let url = vm.apiUrl;
                url = url.replace('{apiKey}', vm.apiKey);
                axios.get(url)
                    .then((response) => {
                        vm.data = response.data;
                    })
                    .catch((err) => {
                        vm.error = err;
                    });
            }
        }
    }
</script>
<style lang="css" scoped>

    .iconFilter {
        filter: invert(100%) saturate(3500%) brightness(200%);
        opacity: 0.6;
    }

</style>